import React, { memo } from 'react';
interface SkeletonBlockProps {
  width?: string | number;
  height?: string | number;
  borderRadius?: string | number;
  className?: string;
}
export const SkeletonBlock = memo(function SkeletonBlock({
  width = '100%',
  height = '100%',
  borderRadius = '16px',
  className = ''
}: SkeletonBlockProps) {
  return <div className={`relative overflow-hidden ${className}`} style={{
    width,
    height,
    borderRadius,
    background: 'linear-gradient(90deg, #E9D5FF 25%, #F3E8FF 50%, #E9D5FF 75%)',
    backgroundSize: '200% 100%',
    animation: 'shimmer 1.5s infinite linear'
  }} data-id="element-317" data-mp="c76jrgrzhney">
      <style data-id="element-318" data-mp="3uffhgqpsfjfu">{`
        @keyframes shimmer {
          0% { background-position: 200% 0; }
          100% { background-position: -200% 0; }
        }
      `}</style>
    </div>;
});